import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumItemMainPurpose implements BaseEnumType {
  private static allValues: EnumItemMainPurpose[] = []; // make sure this is top-most
  
  public static unknown = new EnumItemMainPurpose(0, "Unknown", "enum_item_main_purpose_unknown");
  public static material = new EnumItemMainPurpose(1, "Material", "enum_item_main_purpose_material");
  public static product = new EnumItemMainPurpose(2, "Product", "enum_item_main_purpose_product");
  public static deliveryService = new EnumItemMainPurpose(3, "DeliveryService", "enum_item_main_purpose_delivery_service");
  public static bottleDepositCharge = new EnumItemMainPurpose(4, "BottleDepositCharge", "enum_item_main_purpose_bottle_deposit_charge");
  public static bottleDepositRedemption = new EnumItemMainPurpose(5, "BottleDepositRedemption", "enum_item_main_purpose_bottle_deposit_redemption");
  public static autoAssembledItem = new EnumItemMainPurpose(6, "AutoAssembledItem", "enum_item_main_purpose_auto_assembled_item");
  public static poDeliveryService = new EnumItemMainPurpose(7, "PoDeliveryService", "enum_item_main_purpose_po_delivery_service");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumItemMainPurpose.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumItemMainPurpose.unknown; }
  public isMaterial() { return this === EnumItemMainPurpose.material; }
  public isProduct() { return this === EnumItemMainPurpose.product; }
  public isDeliveryService() { return this === EnumItemMainPurpose.deliveryService; }
  public isBottleDepositCharge() { return this === EnumItemMainPurpose.bottleDepositCharge; }
  public isBottleDepositRedemption() { return this === EnumItemMainPurpose.bottleDepositRedemption; }
  public isAutoAssembledItem() { return this === EnumItemMainPurpose.autoAssembledItem; }
  public isPoDeliveryService() { return this === EnumItemMainPurpose.poDeliveryService; }

  public static getValues(): readonly EnumItemMainPurpose[] {
    return EnumItemMainPurpose.allValues;
  }

  public static getValuesExcept0(): readonly EnumItemMainPurpose[] {
    return EnumItemMainPurpose.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumItemMainPurpose {
    const found = EnumItemMainPurpose.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumItemMainPurpose - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumItemMainPurpose): EnumItemMainPurpose {
    const found = name ? EnumItemMainPurpose.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumItemMainPurpose - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumItemMainPurpose>): boolean {
    return this.key === other?.key;
  }
}